<div class="container py-5 login-page-container">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">

      <div class="text-center mb-4 mt-6 pt-5">
        <h1 class="mat-display-1 fw-bold" style="color: #215DAB">Forgot Password?</h1>
        <p class="mat-subheading-2 text-secondary">We'll email you reset instructions</p>
      </div>

      <mat-card class="p-4 shadow-lg rounded" style="background-color: #f8faff;">
        <mat-card-content>
          <mat-progress-spinner class="mx-auto my-3" *ngIf="showProgressSpinner" mode="indeterminate" diameter="40">
          </mat-progress-spinner>

          <app-success-message [message]="this.successMessage"></app-success-message>
          <app-error-message [message]="this.errorMessage"></app-error-message>

          <!-- Form -->
          <form *ngIf="!successMessage" (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
            <p class="text-secondary text-center mb-4">
              Password reset instructions will be sent to your registered email address.
            </p>

            <div class="mb-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Username or email address</mat-label>
                <input
                  type="text"
                  name="name"
                  required
                  matInput
                  ngModel>
                <mat-icon matPrefix class="text-secondary me-2">person</mat-icon>
                <mat-error *ngIf="f.controls['name']?.invalid && f.controls['name']?.touched">
                  Username or email address is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="d-grid gap-2">
              <button
                [disabled]="!f.valid"
                type="submit"
                mat-raised-button
                color="primary"
                class="py-2">
                <span class="d-flex align-items-center justify-content-center">
                  <mat-icon class="me-2">mail</mat-icon>
                  <span>Send Reset Instructions</span>
                </span>
              </button>
            </div>

            <div class="mt-3 text-center">
              <a mat-button routerLink="/auth/login" color="accent">Back to Sign In</a>
            </div>
          </form>

          <!-- Confirmation -->
          <div *ngIf="successMessage" class="text-center">
            <a mat-raised-button color="primary" class="py-2" routerLink="/auth/login">
              <span class="d-flex align-items-center justify-content-center">
                <mat-icon class="me-2">login</mat-icon>
                <span>Back to Sign In</span>
              </span>
            </a>
          </div>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
</div>
